// extracted by mini-css-extract-plugin
export default {"input":"Freshmail_input__Se+ig"};